<template>
  <div class="promoterBox">
    <div class="searchContentBox">
      <Search :searchOpt="searchOpt" v-on:serchCallback="serchCallback"></Search>
    </div>
    <div class="main">
      <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
        <ul v-if="list.length > 0">
          <li v-for="(item, index) in list" :key="index">
            <div class="img">
              <img :src="item.headerimg" alt />
            </div>
            <div class="detail">
              <p class="name">{{ item.nickname }}</p>
              <div>
                <p class="contribution">
                  <span>贡献奖励</span>
                  <em>¥ {{ item.secondintroducerid ? util.toFixed(item.scontributionmoney,2) : util.toFixed(item.contributionmoney,2)}}</em>
                </p>
              </div>
            </div>
          </li>
        </ul>
        <div class="notDataBox" v-else>
          <NotData class="dynamic" title="暂无推广员"></NotData>
        </div>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import Search from "@/components/search";
import NotData from "@/components/notData";
import MescrollVue from "mescroll.js/mescroll.vue";

export default {
  name: "promoter",
  metaInfo() {
    return {
      title: "累计推广员",
    };
  },
  data() {
    return {
      list: [],
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        auto: false,
        callback: this.downCallback,
      },
      mescrollUp: {
        callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
        //以下是一些常用的配置,当然不写也可以的.
        htmlNodata: '<p class="upwarp-nodata">暂无更多数据</p>',
        page: {
          num: 0,
          size: 10,
        },
        noMoreSize: 5, //如果列表已无数据,可设置列表总数大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          // warpId: "xxid", //父布局的id (1.3.5版本支持传入dom元素)
          //icon: "./static/mescroll/mescroll-empty.png", //图标,默认null,支持网络图
          tip: "暂无相关数据~", //提示
        },
      },
      searchOpt: {
        tip: "请输入用户名称查找",
      },
      searchText: "",
    };
  },
  components: {
    MescrollVue,
    Search,
    NotData,
  },
  mounted() {},
  methods: {
    serchCallback(data) {
      if (data.type == "search") {
        // if (data.searchText) {
        this.searchText = data.searchText;
        this.mescroll.resetUpScroll();
        // }
      } else if (data.type == "cancel") {
        if (this.searchText) {
          this.searchText = "";
        }
      }
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
    },
    downCallback() {
      this.mescroll.resetUpScroll();
    },
    upCallback(page, mescroll) {
      this.getListDataFromNet(page.num, page.size, mescroll);
    },
    getListDataFromNet(num, size, mescroll) {
      if (num == 1) {
        this.list = [];
      }
      var obj = {
        diststate: "1001",
        pageNum: num,
        pageSize: size,
        nickname: this.searchText,
      };
      this.$post(
        "/iart-api-crm/api/crm/custdistribution/queryByDistributionList",
        obj
      ).then((res) => {
        if (res.code == 1) {
          var data = res.data && res.data.rows ? res.data.rows : [];
          this.list = this.list.concat(data);
          this.$nextTick(() => {
            mescroll.endSuccess(data.length);
          });
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.promoterBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  .searchContentBox {
    padding: 6px 16px;
  }
  .main {
    flex: 1;
    overflow: auto;
    margin-top: 6px;
    ul {
      padding-left: 16px;
      li {
        display: flex;
        flex-direction: row;
        padding-top: 20px;
        .img {
          height: 60px;
          padding-bottom: 20px;
          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
            vertical-align: middle;
          }
        }
        .detail {
          padding-bottom: 20px;
          padding-right: 16px;
          flex: 1;
          margin-left: 12px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .name {
            font-size: 14px;
            line-height: 20px;
            color: #333333;
            font-weight: 600;
          }
          div {
            margin-left: 12px;
            .contribution {
              font-size: 12px;
              line-height: 17px;
              color: #333333;
              em {
                font-weight: 600;
              }
            }
            .tip {
              font-size: 12px;
              line-height: 17px;
              color: #999999;
              margin-top: 4px;
            }
          }
        }
      }
      li:not(:last-child) {
        .detail {
          border-bottom: 1px solid #ededed;
        }
      }
    }
  }
}
</style>